import { computed } from '@vue/composition-api';
import { date } from '@/util/formatters';
import { OfferStatus } from '@/api/v2/requests/offers';
import { DummyFilter } from '@/components/Table/dummy-filter';
export const useOfferColumns = (ctx) => {
    const columns = computed(() => {
        return [
            {
                field: 'internalNumber',
                headerName: '#',
                sortable: true,
                width: 115,
                minWidth: 115,
                flex: 0,
                filter: DummyFilter,
                floatingFilter: true,
                floatingFilterComponent: 'FloatingTextFilter',
                suppressFloatingFilterButton: true,
            },
            {
                field: 'title',
                headerName: ctx.root.$t('brand-offers.title').toString(),
                flex: 1,
                minWidth: 150,
                sortable: true,
                filter: DummyFilter,
                floatingFilter: true,
                floatingFilterComponent: 'FloatingTextFilter',
                suppressFloatingFilterButton: true,
            },
            {
                field: 'centralCost.name',
                headerName: ctx.root.$t('brand-offers.cost-center').toString(),
                flex: 1,
                minWidth: 150,
                sortable: true,
                filter: DummyFilter,
                floatingFilter: true,
                floatingFilterComponent: 'FloatingTextFilter',
                suppressFloatingFilterButton: true,
            },
            {
                field: 'status',
                headerName: ctx.root.$t('brand-offers.status').toString(),
                width: 210,
                cellRenderer: 'OfferStatusCell',
                cellRendererParams: (params) => ({
                    status: params?.data.status,
                }),
                filter: DummyFilter,
                floatingFilter: true,
                floatingFilterComponent: 'FloatingSelectFilter',
                floatingFilterComponentParams: () => ({
                    options: Object.values(OfferStatus)
                        .filter((status) => status !== OfferStatus.DRAFT)
                        .map((status) => ({
                        value: status,
                        label: status,
                    })),
                    getLabel: (status) => {
                        return ctx.root.$t(`offer-status.${status}`).toString();
                    },
                }),
                suppressFloatingFilterButton: true,
            },
            {
                field: 'createdAt',
                headerName: ctx.root.$t('brand-offers.created').toString(),
                sortable: true,
                cellRenderer: (params) => date(params?.data.createdAt),
            },
        ];
    });
    return { columns };
};
